import { hydrate } from "./hydration.js";
const scalarMermaid = { hydrate };
export {
  scalarMermaid
};
//# sourceMappingURL=index.js.map
